var map = {
	"./0.svg": 631,
	"./1.svg": 7827,
	"./2.svg": 4548,
	"./3.svg": 226,
	"./4.svg": 6761,
	"./5.svg": 4266,
	"./6.svg": 5227,
	"./7.svg": 9465,
	"./8.svg": 9853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7892;